// management-frontend/src/components/Login.js
// src/components/Login.js

import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const Login = () => {
  const [view, setView] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, redirectPath, forgotPassword } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const result = await login(email, password);

      if (result?.success) {
        if (result.initialPassword) {
          navigate("/change-password");
        } else {
          navigate(redirectPath || "/");
        }
      } else {
        alert("Credenciais inválidas!");
      }
    } catch (err) {
      alert("Credenciais inválidas!");
    }
  };

  const handleViewForgotPassword = async (e) => {
    setView("forgotPassword");
  };

  const handleForgotPassword = async (e) => {
    if (!email) alert("Favor informar o e-mail");
    else {
      const check = await forgotPassword(email);

      if (!check) alert("Erro ao solicitar resete de senha");
      else {
        alert("Resete de senha solicitado com sucesso");
        setView("login");
      }
    }
  };

  const viewLogin = () => {
    return view !== "login" ? (
      ""
    ) : (
      <>
        <div className="form-group">
          <input className="form-control my-2" type="password" placeholder="Senha" onChange={(e) => setPassword(e.target.value)} />
        </div>
        <button
          type="button"
          onClick={handleViewForgotPassword}
          style={{
            fontSize: "12px",
            background: "none",
            border: "none",
            color: "#069",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          Esqueci minha senha
        </button>
        <br /> <br />
        <button type="button" className="btn btn-primary w-100" onClick={handleLogin}>
          Entrar
        </button>
      </>
    );
  };

  const viewForgotPassword = () => {
    return view !== "forgotPassword" ? (
      ""
    ) : (
      <>
        <br /> <br />
        <button type="button" className="btn btn-primary w-100" onClick={handleForgotPassword}>
          Solicitar nova senha
        </button>
      </>
    );
  };

  return (
    <div className="container vh-100 d-flex flex-column">
      <div className="flex-grow-1 d-flex justify-content-center align-items-center">
        <form className="p-4 border rounded shadow bg-light w-100" style={{ maxWidth: "50%" }}>
          <div className="form-group">
            <input className="form-control my-2" type="email" placeholder="E-mail" onChange={(e) => setEmail(e.target.value)} />
          </div>

          {viewLogin()}
          {viewForgotPassword()}
        </form>
      </div>
    </div>
  );
};

export default Login;
